import type { Transform } from "@/api/mapperApi";
import { explainTransform } from "./explainTransform";

const MAX_ROWS = 8;

export function TransformExplainer({ transform }: { transform: Transform }) {
  const ex = explainTransform(transform);
  const shown = ex.table?.slice(0, MAX_ROWS) ?? [];
  const rest = (ex.table?.length ?? 0) - shown.length;
  return (
    <div
      data-testid="transform-explainer"
      style={{
        background: "var(--sapInformationBackground, #e8f4fd)",
        border: "1px solid var(--sapInformativeColor, #0071e3)",
        borderRadius: "8px",
        padding: "10px 12px",
      }}
    >
      <span style={{ fontWeight: 700, display: "block" }}>{ex.title}</span>
      <span style={{ display: "block", marginTop: "2px" }}>{ex.text}</span>
      {shown.length > 0 && (
        <table style={{ borderCollapse: "collapse", marginTop: "8px", fontSize: "0.8rem" }}>
          <tbody>
            {shown.map((r) => (
              <tr key={r.code}>
                <td style={{ fontFamily: "monospace", padding: "2px 12px 2px 0" }}>{r.code}</td>
                <td style={{ color: "var(--sapContent_LabelColor)", padding: "2px 8px" }}>→</td>
                <td style={{ padding: "2px 0" }}>{r.meaning}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {rest > 0 && (
        <span style={{ display: "block", marginTop: "4px", color: "var(--sapContent_LabelColor)" }}>
          … und {rest} weitere
        </span>
      )}
      {ex.raw && (
        <pre style={{ marginTop: "8px", fontSize: "0.72rem", whiteSpace: "pre-wrap" }}>{ex.raw}</pre>
      )}
    </div>
  );
}
